export const Phone = {
    computed: {
        phone: {
            get() {
                return this.$store.state.phone
            }
        }
    },
    mounted() {
        let node = BX('form_auth_phone')

        let result = new BX.MaskedInput({
            mask: '9 (999) 999-99-99',
            input: node,
            placeholder: '_'
        })

        if (this.$store.state.phone)
            result.setValue(this.$store.state.phone)

        BX.addCustomEvent(result, 'change', value => this.$store.commit('setPhone', value))
    },
    template: `
    <div class="form" v-if="this.$store.state.step === 'initial'">
        <div class="form-group form-control">
            <input type="text" placeholder=" " id="form_auth_phone">
            <label for="form_auth_phone">{{ this.$store.state.messages.phoneLabel }}</label>
        </div>
        <div class="form-group form-buttons form-buttons--column">
            <span v-bind:class="{'button': true, 'button-load': this.$store.state.loading === true}" @click="$emit('sendCode')">{{ this.$store.state.messages.requestCode }}</span>
        </div>
        <div class="licence">
            <span v-html="this.$store.state.messages.agreement"></span><a href="${window.siteDir || '/'}licenses/" target="_blank">{{ this.$store.state.messages.privacy }}</a><span v-html="this.$store.state.messages.agreementAnd"></span><a href="${window.siteDir || '/'}licenses/terms/" class="underlined" target="_blank">{{ this.$store.state.messages.terms }}</a>
        </div>
    </div>
    `
}
